"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validatePhoneNumberInternational;
exports.getCountryCode = getCountryCode;
exports.validateNumber = validateNumber;
var _libphonenumberJs = require("libphonenumber-js");
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var _countries = _interopRequireDefault(require("../../utils/content/countries"));
var _replaceStringVars = _interopRequireDefault(require("../../utils/string/replaceStringVars"));
var _phoneNumberUK = _interopRequireDefault(require("./phoneNumberUK"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// ensure domestic format numbers are always treated as GB
function getCountryCode(number, countryCode) {
  var isDomesticFormat = number && !number.match(/^(00[1-9]+)|(\+[1-9]+)/);
  return number && isDomesticFormat ? 'GB' : countryCode;
}
function validateNumber(number, defaultCountryCode) {
  var countryCode = getCountryCode(number, defaultCountryCode);
  try {
    var phoneNumber = (0, _libphonenumberJs.parsePhoneNumber)(number, countryCode);
    return phoneNumber;
  } catch (error) {
    return {
      isValid: function isValid() {
        return false;
      }
    };
  }
}
function getInvalidErrorMessage(countryCode, number, validationMessageKeys) {
  if (countryCode) {
    var country = (0, _find["default"])(_countries["default"], {
      value: countryCode
    });
    if (countryCode === 'GB') {
      // ensure we pass a valid uk number format to validatePhoneNumberUK()
      // converts +440 -> 0 || +44(0) -> 0
      var nationalNumber = number.replace(/^((\+44\(.*\))|(\+44(0*)))/, '0');
      var message = (0, _phoneNumberUK["default"])(nationalNumber, validationMessageKeys);
      return message;
    }
    return (0, _replaceStringVars["default"])(validationMessageKeys.invalid, {
      country: (0, _get["default"])(country, 'label')
    });
  }
  return validationMessageKeys.invalidUnknown;
}
function validatePhoneNumberInternational(number, validationMessageKeys, countryCode) {
  var phoneNumber = validateNumber(number, countryCode);
  if (phoneNumber.isValid()) {
    return undefined;
  }
  if (!phoneNumber.isValid()) {
    return getInvalidErrorMessage(countryCode, number, validationMessageKeys);
  }
  return undefined;
}